import { FuelCallout, FuelTypography } from '@frete.com/fuel-react';
import React, { FC } from 'react';
import * as Styled from '../styled';

const ProcessingProfile: FC = () => (
  <FuelCallout icon="clock" iconStyle="filled" fullWidth>
    <Styled.ContentWrapper slot="content" data-testid="gr-processing-profile">
      <FuelTypography size="caption" weight="medium">
        O perfil desse motorista <strong>está em análise</strong> na Gestão de Risco Fretebras.
      </FuelTypography>
    </Styled.ContentWrapper>
  </FuelCallout>
);

export default ProcessingProfile;
